export default "__VITE_ASSET__D1fMokic__"